import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner, Button } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  putRequestForm,
  postRequest,
  postRequestForm,
} from "components/Common/Utils.js";
import Lightbox from "react-image-lightbox";


const PermissionsForm = ({ permissions, onChange }) => {
  return (
    <div>
      <h3>Set Permissions</h3>
      {Object.entries(permissions).map(([permissionKey, permissionValue]) => (
        <div key={permissionKey} className="permisstion-types">
          <label>
            <input
              type="checkbox"
              checked={permissionKey === 'dashboard' ? permissionValue : permissionValue.allAccess}
              onChange={(e) => onChange(permissionKey, e.target.checked)}
            />
            {permissionKey}
          </label>
        </div>
      ))}
    </div>
  );
};


export default function RoleUpdate() {
  const location = useLocation();
  const state = location.state?.row;
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [isFileSelect, setIsFileSelect] = useState(false);
  const [veriFiedDocument, setveriFiedDocument] = useState([{ documentImage: "" }]);

  const [permissions, setPermissions] = useState({
    dashboard:  false,
    usermanagement: { allAccess: false },
    bannerManagement: { allAccess: false },
    categoryManagement: { allAccess: false },
    HomeBlockManagement: { allAccess: false },
    productManagement: { allAccess: false },
    supportManagement: { allAccess: false },
    faqsManagement: { allAccess: false },
    orderManagement: { allAccess: false },
    warehouseManagement: { allAccess: false },
    NotificationManagement: { allAccess: false },
    adminManagement: { allAccess: false },
  });

  const updatePermission = (key, value) => {
    let updatedPermissions;
    if (key === 'dashboard') {
      updatedPermissions = {
        ...permissions,
        [key]: value,
      };
    } else {
      updatedPermissions = {
        ...permissions,
        [key]: { allAccess: value },
      };
    }
    setPermissions(updatedPermissions);
    setFormValues((prevValues) => ({
      ...prevValues,
      permissions: updatedPermissions, 
    }));
  };


  const [formValues, setFormValues] = useState({
    subadminId : '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    dob: '',
    image: '',
    gender: '',
    password: '',
    type: '',
    address: '',
    postCode: '',
    country: '',
    permissions: ''
  });

  const handleChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    if (state) {
      setFormValues(state);
      setPermissions(state?.permissions);
      // setPreviewImage(state.image);
    }
    console.log(permissions);
  }, [state]);

  const updateDocument = (key, file) => {
    setIsFileSelect(true);
    const previewUrl = URL.createObjectURL(file);
    const updatedDocuments = veriFiedDocument.map((doc, i) => {
      return { ...doc, [key]: file, previewUrl };
    });
    setveriFiedDocument(updatedDocuments);
    setveriFiedDocument(updatedDocuments);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    let documentImage = '';
    if (isFileSelect) {
      if (veriFiedDocument?.[0]?.doc) {
        const selectedImage = new FormData();
        selectedImage.append("image", veriFiedDocument[0].doc);
        const selectedImageUrl = await postRequestForm("image/img/upload", selectedImage);
        documentImage = selectedImageUrl?.data?.url || '';
      }
    }
    let formValue = formValues;
    formValue.image = documentImage || '';
    formValue.subadminId = formValue._id || '';
    setLoading(true);
    const response = await postRequest("admin/update", formValue);
    if (response.status) {
      toast.success(response.message);
      setLoading(false);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      setLoading(false);
      toast.error(response.message);
    }
  };
  let history = useHistory();

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="row">
        <div className="col-lg-10">
          <div className="page-title-box">
            <h4>Role Access Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Role Access Management</li>:{" "}
              <li className="breadcrumb-item">Create Access</li>
            </ol>
          </div>
        </div>
        <div class="col-md-2 text-end">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="btn btn-primary btn-lg"
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> Create Role</h4>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        {/* First Name */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">First Name</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => handleChange("first_name", e.target.value)}
                              value={formValues.first_name}
                              name="first_name"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Last Name */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Last Name</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => handleChange("last_name", e.target.value)}
                              value={formValues.last_name}
                              name="last_name"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Email Address */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Email Address</label>
                          <div className="col-sm-6">
                            <input
                              type="email"
                              onChange={(e) => handleChange("email", e.target.value)}
                              value={formValues.email}
                              name="email"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Mobile No. */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Mobile No.</label>
                          <div className="col-sm-6">
                            <input
                              type="number"
                              onChange={(e) => handleChange("phone", e.target.value)}
                              value={formValues.phone}
                              name="phone"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* DOB */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">DOB</label>
                          <div className="col-sm-6">
                            <input
                              type="date"
                              onChange={(e) => handleChange("dob", e.target.value)}
                              value={formValues.dob}
                              name="dob"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Image */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Image</label>
                          <div className="col-sm-6">
                            <input
                              type="file"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  updateDocument("doc", file);
                                }
                              }}
                              name="image"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Gender */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Gender</label>
                          <div className="col-sm-6">
                            <select
                              className="form-control"
                              name="gender"
                              onChange={(e) => handleChange("gender", e.target.value)}
                              value={formValues.gender}
                            >
                              <option value="">Select Gender</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                        </div>

                        {/* Password */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Password</label>
                          <div className="col-sm-6">
                            <input
                              type="password"
                              onChange={(e) => handleChange("password", e.target.value)}
                              value={formValues.password}
                              name="password"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Type */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Type</label>
                          <div className="col-sm-6">
                            <select
                              className="form-control"
                              name="type"
                              onChange={(e) => handleChange("type", e.target.value)}
                              value={formValues.type}
                            >
                              <option value="">Please select..</option>
                              <option value="subAdmin">Sub Admin</option>
                            </select>
                          </div>
                        </div>

                        {formValues.type === 'subAdmin' &&
                          <div className="row mb-4">
                            <label className="col-sm-3 col-form-label"></label>
                            <div className="col-sm-6">
                              <PermissionsForm
                                permissions={permissions}
                                onChange={updatePermission}
                              />
                            </div>
                          </div>
                        }

                        {/* Address */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Address</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => handleChange("address", e.target.value)}
                              value={formValues.address}
                              name="address"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Post Code */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Post Code</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => handleChange("postCode", e.target.value)}
                              value={formValues.postCode}
                              name="postCode"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Country */}
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Country</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => handleChange("country", e.target.value)}
                              value={formValues.country}
                              name="country"
                              className="form-control"
                            />
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button type="submit" className="btn btn-primary w-md">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}

    </React.Fragment>
  );
}
